import fly, { genFormData } from './fly'
import { getAuth } from '@/util/storage'
const auth = //'YOHY9yMUtbGNc3cKeSFAjFTS5diAS-t910nrxQtxdVBZuEBKt36NNDp04FcFXGZe'
getAuth()

// 修改密码
export const fetchChangePwd = (params: Object) =>
    fly.post(`/base/user/editPasswd.json`, genFormData({ auth, ...params }))
        .then(res => res.data)